let mouseDown = false

window.addEventListener("mousedown", () => (mouseDown = true))
window.addEventListener("mouseup", () => (mouseDown = false))

export const clientRectangleContainsPosition = function(rectangle, x, y) {
    return x >= rectangle.left && x <= rectangle.right && y >= rectangle.top && y <= rectangle.bottom
}

export const maxZIndex = function() {
    return (
        Array.from(document.querySelectorAll("body *"))
            .map(a => parseFloat(window.getComputedStyle(a).zIndex))
            .filter(a => !isNaN(a))
            .sort((a, b) => a - b)
            .pop() || 0
    )
}

export const isMouseDown = function() {
    return mouseDown
}

export const arrayFrom = function(nodeList) {
    if (Array.from) return Array.from(nodeList)
    const array = []
    // iterate backwards ensuring that length is an UInt32
    for (let i = nodeList.length >>> 0; i--;) {
        array[i] = nodeList[i]
    }
    return array
}

export const tableToArray = function(table) {
    return arrayFrom(table.children)
        .filter(el => el.matches("thead,tbody,tfoot"))
        .flatMap(el => arrayFrom(el.children).filter(row => row.matches("tr")))
        .map(row => {
            const result = []

            arrayFrom(row.children)
                .filter(col => col.matches("td,th"))
                .forEach(col => {
                    result.push(("" + col.innerText).trim())
                    const colspan = parseInt(col.getAttribute("colspan")) || 1

                    if (colspan > 1) {
                        for (let i = 0, len = colspan - 1; i < len; i++) {
                            result.push("")
                        }
                    }
                })

            return result
        })
}

export const whenMouseUp = function() {
    if (!mouseDown) {
        return Promise.resolve()
    }

    return new Promise(resolve => {
        const callback = function() {
            window.removeEventListener("mouseup", callback)
            resolve()
        }

        window.addEventListener("mouseup", callback)
    })
}

export default {
    arrayFrom,
    isMouseDown,
    maxZIndex,
    tableToArray,
    whenMouseUp,
}
